var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.75 3.375C48.6451 3.375 49.5035 3.73058 50.1365 4.36352C50.7694 4.99645 51.125 5.8549 51.125 6.75V33.75C51.125 34.6451 50.7694 35.5036 50.1365 36.1365C49.5035 36.7694 48.6451 37.125 47.75 37.125H15.3973C13.6072 37.1254 11.8906 37.8368 10.625 39.1028L3.875 45.8528V6.75C3.875 5.8549 4.23058 4.99645 4.86351 4.36352C5.49645 3.73058 6.35489 3.375 7.25 3.375H47.75ZM7.25 0C5.45979 0 3.7429 0.711159 2.47703 1.97703C1.21116 3.2429 0.5 4.95979 0.5 6.75L0.5 49.9264C0.500071 50.2603 0.5992 50.5867 0.784841 50.8642C0.970482 51.1418 1.23429 51.358 1.54287 51.4856C1.85146 51.6131 2.19095 51.6463 2.51837 51.5808C2.8458 51.5153 3.14644 51.3542 3.38225 51.1178L13.0111 41.4889C13.6439 40.8559 14.5022 40.5002 15.3973 40.5H47.75C49.5402 40.5 51.2571 39.7889 52.523 38.523C53.7888 37.2571 54.5 35.5402 54.5 33.75V6.75C54.5 4.95979 53.7888 3.2429 52.523 1.97703C51.2571 0.711159 49.5402 0 47.75 0L7.25 0Z",
    fill: "url(#paint0_linear_163_524)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_524",
    x1: 27.5,
    y1: -0.0000015382,
    x2: 27.5,
    y2: 51.5536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.10dca549cab5b88897d60073dd925186.svg";
export { ForwardRef as ReactComponent };